import { DEFAULT_PAGINATION } from 'application/pages/constants';
import {
  DevicesGroupStatuses,
  SmartlkDevicesGroupQuerySort,
  usePointsGroupsStatusesQuery,
} from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { useAppSelector } from '@shared/store';
import { selectIsAddressesGroupsAvailable } from '@shared/lib/featureFlags';
import { useAccountCompanyId } from './account/useAccountCompanyId';

export const usePointsGroupsErrors = () => {
  const companyId = useAccountCompanyId();
  const isAddressesGroupsAvailable = useAppSelector(selectIsAddressesGroupsAvailable);

  const { data } = usePointsGroupsStatusesQuery({
    variables: {
      pagination: DEFAULT_PAGINATION,
      filters: { companyId, statuses: [DevicesGroupStatuses.Valid, DevicesGroupStatuses.Valid] },
      sort: SmartlkDevicesGroupQuerySort.IdDesc,
    },
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    skip: !companyId || !isAddressesGroupsAvailable,
  });

  return Boolean(data?.smartlkDevicesGroupPaginationQuery?.statusesInfo?.valid);
};
